/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MultiSelectOperationStitchNblcs } from '../model/';
// @ts-ignore
import type { StyleOperationStitchNBLCCreateDto } from '../model/';
// @ts-ignore
import type { StyleOperationStitchNBLCDto } from '../model/';
// @ts-ignore
import type { StyleOperationStitchNBLCDtoPagedResultDto } from '../model/';
// @ts-ignore
import type { StyleOperationStitchNBLCUpdateDto } from '../model/';
/**
 * StyleOperationStitchNBLCApi - axios parameter creator
 * @export
 */
export const StyleOperationStitchNBLCApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} [operationIds] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetStyleOperationNblcsGet: async (operationIds?: Array<number>, tktTexValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getStyleOperationNblcs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (operationIds) {
                localVarQueryParameter['operationIds'] = operationIds;
            }

            if (tktTexValue !== undefined) {
                localVarQueryParameter['tktTexValue'] = tktTexValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetUniqueUsedShadesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getUniqueUsedShades`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCGet: async (sorting?: string, skipCount?: number, maxResultCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/styleOperationStitchNBLC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStyleOperationStitchNBLCIdDelete', 'id', id)
            const localVarPath = `/api/styleOperationStitchNBLC/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStyleOperationStitchNBLCIdGet', 'id', id)
            const localVarPath = `/api/styleOperationStitchNBLC/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StyleOperationStitchNBLCUpdateDto} [styleOperationStitchNBLCUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCIdPut: async (id: number, styleOperationStitchNBLCUpdateDto?: StyleOperationStitchNBLCUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStyleOperationStitchNBLCIdPut', 'id', id)
            const localVarPath = `/api/styleOperationStitchNBLC/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationStitchNBLCUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StyleOperationStitchNBLCCreateDto} [styleOperationStitchNBLCCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCPost: async (styleOperationStitchNBLCCreateDto?: StyleOperationStitchNBLCCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/styleOperationStitchNBLC`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationStitchNBLCCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [tktTexValue] 
         * @param {Array<MultiSelectOperationStitchNblcs>} [multiSelectOperationStitchNblcs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateOperationNblcsPost: async (tktTexValue?: string, multiSelectOperationStitchNblcs?: Array<MultiSelectOperationStitchNblcs>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/updateOperationNblcs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (tktTexValue !== undefined) {
                localVarQueryParameter['tktTexValue'] = tktTexValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiSelectOperationStitchNblcs, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StyleOperationStitchNBLCApi - functional programming interface
 * @export
 */
export const StyleOperationStitchNBLCApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StyleOperationStitchNBLCApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [operationIds] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetStyleOperationNblcsGet(operationIds?: Array<number>, tktTexValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MultiSelectOperationStitchNblcs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetStyleOperationNblcsGet(operationIds, tktTexValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiGetStyleOperationNblcsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetUniqueUsedShadesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetUniqueUsedShadesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiGetUniqueUsedShadesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationStitchNBLCGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationStitchNBLCDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationStitchNBLCGet(sorting, skipCount, maxResultCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiStyleOperationStitchNBLCGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationStitchNBLCIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationStitchNBLCIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiStyleOperationStitchNBLCIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationStitchNBLCIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationStitchNBLCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationStitchNBLCIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiStyleOperationStitchNBLCIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {StyleOperationStitchNBLCUpdateDto} [styleOperationStitchNBLCUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationStitchNBLCIdPut(id: number, styleOperationStitchNBLCUpdateDto?: StyleOperationStitchNBLCUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationStitchNBLCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationStitchNBLCIdPut(id, styleOperationStitchNBLCUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiStyleOperationStitchNBLCIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StyleOperationStitchNBLCCreateDto} [styleOperationStitchNBLCCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationStitchNBLCPost(styleOperationStitchNBLCCreateDto?: StyleOperationStitchNBLCCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationStitchNBLCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationStitchNBLCPost(styleOperationStitchNBLCCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiStyleOperationStitchNBLCPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [tktTexValue] 
         * @param {Array<MultiSelectOperationStitchNblcs>} [multiSelectOperationStitchNblcs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateOperationNblcsPost(tktTexValue?: string, multiSelectOperationStitchNblcs?: Array<MultiSelectOperationStitchNblcs>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateOperationNblcsPost(tktTexValue, multiSelectOperationStitchNblcs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationStitchNBLCApi.apiUpdateOperationNblcsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StyleOperationStitchNBLCApi - factory interface
 * @export
 */
export const StyleOperationStitchNBLCApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StyleOperationStitchNBLCApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [operationIds] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetStyleOperationNblcsGet(operationIds?: Array<number>, tktTexValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MultiSelectOperationStitchNblcs>> {
            return localVarFp.apiGetStyleOperationNblcsGet(operationIds, tktTexValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetUniqueUsedShadesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiGetUniqueUsedShadesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationStitchNBLCDtoPagedResultDto> {
            return localVarFp.apiStyleOperationStitchNBLCGet(sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStyleOperationStitchNBLCIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationStitchNBLCDto> {
            return localVarFp.apiStyleOperationStitchNBLCIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StyleOperationStitchNBLCUpdateDto} [styleOperationStitchNBLCUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCIdPut(id: number, styleOperationStitchNBLCUpdateDto?: StyleOperationStitchNBLCUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationStitchNBLCDto> {
            return localVarFp.apiStyleOperationStitchNBLCIdPut(id, styleOperationStitchNBLCUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StyleOperationStitchNBLCCreateDto} [styleOperationStitchNBLCCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationStitchNBLCPost(styleOperationStitchNBLCCreateDto?: StyleOperationStitchNBLCCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationStitchNBLCDto> {
            return localVarFp.apiStyleOperationStitchNBLCPost(styleOperationStitchNBLCCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [tktTexValue] 
         * @param {Array<MultiSelectOperationStitchNblcs>} [multiSelectOperationStitchNblcs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateOperationNblcsPost(tktTexValue?: string, multiSelectOperationStitchNblcs?: Array<MultiSelectOperationStitchNblcs>, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiUpdateOperationNblcsPost(tktTexValue, multiSelectOperationStitchNblcs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StyleOperationStitchNBLCApi - object-oriented interface
 * @export
 * @class StyleOperationStitchNBLCApi
 * @extends {BaseAPI}
 */
export class StyleOperationStitchNBLCApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} [operationIds] 
     * @param {string} [tktTexValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiGetStyleOperationNblcsGet(operationIds?: Array<number>, tktTexValue?: string, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiGetStyleOperationNblcsGet(operationIds, tktTexValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiGetUniqueUsedShadesGet(options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiGetUniqueUsedShadesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiStyleOperationStitchNBLCGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiStyleOperationStitchNBLCGet(sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiStyleOperationStitchNBLCIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiStyleOperationStitchNBLCIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiStyleOperationStitchNBLCIdGet(id: number, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiStyleOperationStitchNBLCIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StyleOperationStitchNBLCUpdateDto} [styleOperationStitchNBLCUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiStyleOperationStitchNBLCIdPut(id: number, styleOperationStitchNBLCUpdateDto?: StyleOperationStitchNBLCUpdateDto, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiStyleOperationStitchNBLCIdPut(id, styleOperationStitchNBLCUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StyleOperationStitchNBLCCreateDto} [styleOperationStitchNBLCCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiStyleOperationStitchNBLCPost(styleOperationStitchNBLCCreateDto?: StyleOperationStitchNBLCCreateDto, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiStyleOperationStitchNBLCPost(styleOperationStitchNBLCCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [tktTexValue] 
     * @param {Array<MultiSelectOperationStitchNblcs>} [multiSelectOperationStitchNblcs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationStitchNBLCApi
     */
    public apiUpdateOperationNblcsPost(tktTexValue?: string, multiSelectOperationStitchNblcs?: Array<MultiSelectOperationStitchNblcs>, options?: RawAxiosRequestConfig) {
        return StyleOperationStitchNBLCApiFp(this.configuration).apiUpdateOperationNblcsPost(tktTexValue, multiSelectOperationStitchNblcs, options).then((request) => request(this.axios, this.basePath));
    }
}

